import List from './components/List'
import Show from './components/Show'

export default [
  {path: '/evaluation/:status', component: List, name: 'evaluation.index'},
  {path: '/evaluation/:id/show', component: Show, name: 'evaluation.show'}
]
